
function addIconFileInput(inputBody){
    const i = document.createElement("i");

    i.classList.add("icon");

    inputBody.appendChild(i);

    return i;
}

function checkFilledFileInput(inputBody){
    const input = inputBody.querySelector("input");
    const span = inputBody.querySelector("span");
    const i = inputBody.querySelector('i');

    let labelChoose = "Select file";
    let labelChosen = "files selected";

    if (typeof GLOBALS !== 'undefined') {
        if(GLOBALS.tc && GLOBALS.tc.chooseFiles){
            labelChoose = GLOBALS.tc.chooseFiles;
        }
        if(GLOBALS.tc && GLOBALS.tc.chosenFiles){
            labelChosen = GLOBALS.tc.chosenFiles;
        }
    }

    let value = "";
    if(input.files.length > 0) {
        value = input.files[0].name;
        if(input.files.length > 1) {
            value = input.files.length + " " + labelChosen;
        }
        i.classList.add("icon-trash");
        i.classList.remove("icon-upload");
        inputBody.classList.add("is-active");
    }else{
        value = labelChoose;
        i.classList.add("icon-upload");
        i.classList.remove("icon-trash");
        inputBody.classList.remove("is-active");
    }
    span.innerHTML = value;
}

export function initInputBody(query = document.querySelectorAll(".fileBody")) {
    for(const inputBody of query) {
        const input = inputBody.querySelector("input");
        const span = inputBody.querySelector("span");

        if(input && span) {

            const infieldInputGroup = input.closest(".infieldInputGroup");
            if(infieldInputGroup){
                infieldInputGroup.classList.add("is-focus");
            }
            const i = addIconFileInput(inputBody);
            checkFilledFileInput(inputBody);
            input.addEventListener("change", function () {
                checkFilledFileInput(inputBody);
            });

            i.addEventListener("click",function (){
                if(inputBody.classList.contains("is-active")){
                    input.value = "";
                    checkFilledFileInput(inputBody);
                }else{
                    input.click();
                }
            });
        }
    }
}